import './index.scss'
import Swiper from 'swiper/js/swiper.min.js'

$('.ny-nav .swiper .swiper-slide').eq(0).addClass('active')

var swiper1 = new Swiper(".section1 .cont .left .mySwiper", {
  speed: 600,
  loop: true,
  spaceBetween : 30,
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".section1 .cont .left .swiper-pagination",
    clickable: true
  },
});


var swiper2 = new Swiper(".section2 .cont-img .mySwiper", {
  speed: 600,
  loop: true,
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".section2 .cont-img .swiper-pagination",
    clickable: true
  },
});

var swiper3 = new Swiper(".section3 .cont-img .mySwiper", {
  speed: 600,
  loop: true,
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".section3 .cont-img .swiper-pagination",
    clickable: true
  },
});

var swiper4 = new Swiper(".section4 .mySwiper1", {
  speed: 600,
  loop: true,
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".section4 .mySwiper1 .swiper-pagination",
    clickable: true
  },
});
var swiper5 = new Swiper(".section4 .mySwiper2", {
  speed: 600,
  loop: true,
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".section4 .mySwiper2 .swiper-pagination",
    clickable: true
  },
});

var beforeScroH = $(document).scrollTop();
$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //滚动高度
  var viewH = $(window).height(); //可见高度

  //二级导航高亮对应
  let page1H = $('#page1').offset().top - viewH/4
  let page2H = $('#page2').offset().top - viewH/4
  let page3H = $('#page3').offset().top - viewH/4
  let page4H = $('#page4').offset().top - viewH/4
  let page5H = $('#page5').offset().top - viewH/4

  if(scroH < page2H){
    $('.ny-nav .swiper .swiper-slide').eq(0).addClass('active').siblings().removeClass('active')
  }else if(scroH > page2H && scroH < page3H){
    $('.ny-nav .swiper .swiper-slide').eq(1).addClass('active').siblings().removeClass('active')
  }else if(scroH > page3H && scroH < page4H){
    $('.ny-nav .swiper .swiper-slide').eq(2).addClass('active').siblings().removeClass('active')
  }else if(scroH > page4H && scroH < page5H){
    $('.ny-nav .swiper .swiper-slide').eq(3).addClass('active').siblings().removeClass('active')
  }else if(scroH > page5H ){
    $('.ny-nav .swiper .swiper-slide').eq(4).addClass('active').siblings().removeClass('active')
  }
});

$('header .mob-header>ul>li .sub-title .slide-nav li .slide-title a').on('click',function(){
  $('.header .right-fun .hamburger').removeClass('active')
  $('.mob-header').removeClass('active')
  $('.pc-header').removeClass('mob-active')
  $('.mob-header>ul>li .sub-title').removeClass('active')
})